import {
  animate,
  AUTO_STYLE,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const COLLAPSE_DURATION = 150;

const EXPANDED = { height: AUTO_STYLE, visibility: AUTO_STYLE, opacity: 1 };
const COLLAPSED = { height: '0', visibility: 'hidden', opacity: 0.1 };

/** Bound to a boolean "collapsed" flag on a host that stays in the DOM. */
export const collapseAnimation = trigger('collapse', [
  state('false', style(EXPANDED)),
  state('true', style(COLLAPSED)),
  transition('false => true', animate(COLLAPSE_DURATION + 'ms ease-in')),
  transition('true => false', animate(COLLAPSE_DURATION + 'ms ease-out')),
]);

/** Same motion for an element that is added to and removed from the DOM (`@if`). */
export const collapseEnterLeaveAnimation = trigger('collapseEnterLeave', [
  transition(':enter', [
    style(COLLAPSED),
    animate(COLLAPSE_DURATION + 'ms ease-out', style(EXPANDED)),
  ]),
  transition(':leave', [
    style(EXPANDED),
    animate(COLLAPSE_DURATION + 'ms ease-in', style(COLLAPSED)),
  ]),
]);
